export const translations = {
	'Agent down': {
		no: 'Agent nede',
	},
	'agent are down': {
		no: 'agent nede',
	},
	'agent are in warning': {
		no: 'agent har advarsel',
	},
	'All agents are up': {
		no: 'Alle agenter er oppe',
	},
};
